import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { IGameEnvironment } from '../../../model/gameEnvironment/GameEnvironment';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { usePrompt } from '@yakoffice/shared-components';
import Button from 'react-bootstrap/Button';
import { StringInput } from '../common/StringInput';
import { GameVersionVersionInformation } from '../gameVersions/GameVersionVersionInformation';
import { GameEnvironmentController } from '../../../controllers/gameEnvironmentController';


export interface GameEnvironmentCardProps {
    gameEnvironment: IGameEnvironment;
    updateCallbackTrigger: (clearActiveGameEnvironment?: boolean) => void;
}


export const GameEnvironmentForm: FC<GameEnvironmentCardProps> = observer((props: GameEnvironmentCardProps) => {

    const [pageEdited, setPageEdited] = usePrompt('You have unsaved changes. Are you sure you want to leave?', false);

    // Flush sync to prevent batching which prevents immediate rerender
    const controller = GameEnvironmentController({
        setGameEnvironmentEditStatus: setPageEdited,
        gameEnvironment: props.gameEnvironment,
        updateCallbackTrigger: props.updateCallbackTrigger
    });

    // if (isStateTreeNode(props.gameEnvironment))// So can pass in mock....
    //     onSnapshot(props.gameEnvironment, () => setPageEdited(true));

    const handleNameChange = (value: string) => {
        setPageEdited(true);
        props.gameEnvironment.setName(value);
    };

    const handleDescriptionChange = (value: string) => {
        setPageEdited(true);
        props.gameEnvironment.setDescription(value);
    };

    const handleUrlChange = (value: string) => {
        setPageEdited(true);
        props.gameEnvironment.setConfigApiPublishingUrl(value);
    };

    const handleSlackNotificationWebhookUrlChange = (value: string) => {
        setPageEdited(true);
        props.gameEnvironment.setSlackNotificationWebhookUrl(value);
    };

    return (
        <div className={'m3CardForm'}>
            <Row>
                <Col xl="6">
                    <Form.Group className="position-relative">
                        <Form.Label className="">Name</Form.Label>
                        <StringInput id="geName" value={props.gameEnvironment.name} handleOnChange={handleNameChange}
                                     data-testid="txtGameEnvironmentName" />
                    </Form.Group>
                </Col>
                <Col xl="6">
                    <Form.Group className="position-relative">
                        <Form.Label>Description</Form.Label>
                        <StringInput id="geDescription"
                                     value={props.gameEnvironment.description}
                                     handleOnChange={handleDescriptionChange}
                                     data-testid="txtGameEnvironmentDescription" />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col md="6">
                    <Form.Group className="position-relative">
                        <Form.Label>Config Api Publishing Url <GameVersionVersionInformation /></Form.Label>
                        <StringInput id="geUrl" value={props.gameEnvironment.configApiPublishingUrl}
                                     handleOnChange={handleUrlChange}
                                     data-testid="txtGameEnvironmentPubUrl" />
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="position-relative">
                        <Form.Label>Slack Notification Web Hook Url</Form.Label>
                        <StringInput id="getSlackUrl"
                                     value={props.gameEnvironment.slackNotificationWebhookUrl}
                                     handleOnChange={handleSlackNotificationWebhookUrlChange}
                                     data-testid="txtGameEnvironmentWebHookUrl" />
                    </Form.Group>
                </Col>
            </Row>
            <div className={'footer'}>
                {pageEdited &&
                    <Button onClick={() => controller.saveGameEnvironment()} disabled={!pageEdited}
                            className={'saveUserButton'}
                            data-testid="btnSave"><i className="fas fa-save" />Save</Button>}
                {!props.gameEnvironment.isNew &&
                    <Button variant="danger" className="deleteButton"
                            onClick={() => controller.deleteGameEnvironment()}><i
                        className="fas fa-trash" />Delete</Button>}

            </div>
        </div>
    );
});
